const fetchWithTimeout = async (url: string, options: object, tm: number) => {
  const controller = new AbortController();
  const { signal } = controller;

  const timeout = setTimeout(() => {
    controller.abort();
  }, tm);

  const req = await fetch(url, {
    ...options,
    signal,
  });

  clearTimeout(timeout);

  const result = await req.json();

  return result;
};

export default fetchWithTimeout;
